import React from 'react';
import { styled } from 'linaria/react';
import { cx } from 'linaria';
import Image from '@jetshop/ui/Image';
import { theme } from '../../../Theme';
import { useIntl } from '@jetshop/intl';
import { useQuery } from 'react-apollo';
import Products from './Products.gql';
import { useBase64 } from '../../../../hooks/useBase64';
import { LinkEvaluator } from 'r3-lib/dist/r3lib';

const FamilyMembersWrapper = styled('div')`
  width: 100%;

  label {
    color: #1c1c1c;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: 139.5%; /* 16.74px */
    letter-spacing: 0.48px;
    text-transform: uppercase;
  }
`;

const FamilyMembersItemsWrapper = styled('div')`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin: 0;

  > * {
    width: fit-content;
    margin-bottom: 13px;
  }

  .family-member-item {
    position: relative;
    width: 50px;
    margin-right: 13px;
    .member-image-wrapper {
      background: white;

      &.current {
        outline: 2px solid #004e42;
      }
      img {
        mix-blend-mode: darken;
      }
    }

    &:hover {
      .item-text {
        opacity: 1;
        visibility: visible;
      }
    }

    .item-text {
      position: absolute;
      top: 100%;
      left: 50%;
      transform: translateX(-50%);
      padding: 5px 10px 2px 10px;
      background: #004e42;
      color: #fff;
      font-size: 11px;
      white-space: nowrap;
      margin-top: 10px;

      opacity: 0;
      visibility: hidden;
      transition: all, 0.2s ease;
      &:before {
        content: '';
        width: 0;
        height: 0;
        position: absolute;
        bottom: 100%;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
`;

export const FamilyMembers = ({
  articleNumbers,
  current,
  title,
  customFieldKey,
  setSelectedProduct,
  variant
}) => {
  const { data } = useQuery(Products, {
    variables: {
      articles: articleNumbers
    },
    errorPolicy: 'ignore'
  });

  const translate = useIntl();
  const titleText = translate(title);

  const colorType = current?.customFields?.filter(
    customField => customField?.key === 'Variants'
  )[0]?.stringValue;

  return (
    <FamilyMembersWrapper className="family-members-wrapper">
      <label>
        {titleText} {colorType}
      </label>
      <FamilyMembersItemsWrapper>
        {data?.products?.map((product, index) => {
          return (
            <div key={'family-member-' + index}>
              <FamilyMemberItem
                product={product}
                index={index}
                customFieldKey={customFieldKey}
                setSelectedProduct={setSelectedProduct}
                current={current}
                variant={variant}
              />
            </div>
          );
        })}
      </FamilyMembersItemsWrapper>
    </FamilyMembersWrapper>
  );
};

const FamilyMemberItem = ({
  product,
  index,
  customFieldKey,
  setSelectedProduct,
  variant,
  current
}) => {
  const imageAspect = '1:1';
  const imageSizes = [1 / 2, 1 / 2, 1 / 3, 1 / 4];

  const variantValue = variant?.values?.[0];
  const { encodedText } = useBase64(variantValue ?? '');

  return (
    <LinkEvaluator
      key={`member-${product?.articleNumber}-${index}`}
      link={`${product?.primaryRoute?.path}${
        variantValue ? '?att=' + encodedText : ''
      }`}
      linkClickCallback={e => {
        if (setSelectedProduct) {
          e.preventDefault();
          setSelectedProduct(product);
        }
      }}
    >
      <div className="family-member-item">
        <div
          className={cx(
            'member-image-wrapper',
            current?.articleNumber === product?.articleNumber && 'current'
          )}
        >
          <Image
            src={product?.images?.[0]?.url}
            size={imageSizes}
            aspect={imageAspect}
          />
        </div>
        <div className="item-text">
          {
            product?.customFields?.filter(
              customField => customField?.key === 'Farg'
            )[0]?.stringValue
          }
        </div>
      </div>
    </LinkEvaluator>
  );
};
